import config from '../../config';
import { PredefinedMilisecondsTypeEnum } from '../enums';
import { PeopleAlsoTradeItem, PeopleAlsoTradeParams } from '../models/reporting/types';
import {
  AccountTradeHistoryPayloadData,
  GetAccountsAvailableCashRequest,
  GetAccountTradeHistoryFirstAndLastTradePayload,
  GetAccountTradeHistoryFirstAndLastTradeResponse,
  OpenPositionsPayloadData,
  OrderDetailPayloadData,
  OrderDetailResponse,
} from '../store/reporting/types';

import { CacheName, HttpMethods } from './cache/types';
import { BaseRequestService } from './BaseRequest.service';
import { IReportingService } from './types';

const API_URLS = {
  getAccountsAvailableCash: '/v2/reports-10n/get-available-cash-with-total-base-currency',
  getOpenPositionsData: '/v2/reports-10n/get-open-positions',
  getOrderDetailData: '/v2/reports-10n/get-order-details',
  getAccountTradeHistory: '/v2/reports-10n/get-account-trade-history',
  getAccountTradeHistoryFirstAndLastTrade: '/v2/reports-crm/get-crm-accounts-balance-base-currency',
  peopleAlsoTrade: '/v2/reports-10n/get-people-also-trade',
  getBPInClosedMarket: '/v2/reports-10n/get-buying-power-oms-off',
};

export class ReportingService extends BaseRequestService implements IReportingService {
  protected getBaseUrl(): string {
    return config.reporting.url;
  }

  public getAccountsAvailableCash(requestBody: GetAccountsAvailableCashRequest) {
    const APIPath = API_URLS.getAccountsAvailableCash;
    return this.api.post<any>(APIPath, requestBody);
  }

  public getOrderDetailData(requestBody: OrderDetailPayloadData) {
    const APIPath = API_URLS.getOrderDetailData;
    const url = this.getBaseUrl() + APIPath;
    this.addOrUpdateCacheDefinition(
      url,
      CacheName.orderDetailData,
      HttpMethods.POST,
      PredefinedMilisecondsTypeEnum.fifteenMinutes,
      [ 'parentOrderId', 'accountReferenceId' ],
    );

    return this.api.post<OrderDetailResponse>(APIPath, requestBody);
  }

  public getOpenPositionsData(requestBody: OpenPositionsPayloadData) {
    const APIPath = API_URLS.getOpenPositionsData;
    return this.api.post<any>(APIPath, requestBody);
  }

  public getAccountTradeHistory(requestBody: AccountTradeHistoryPayloadData) {
    return this.api.post<AccountTradeHistoryPayloadData>(API_URLS.getAccountTradeHistory, requestBody);
  }

  public getAccountTradeHistoryFirstAndLastTrade(requestBody: GetAccountTradeHistoryFirstAndLastTradePayload) {
    return this.api.post<GetAccountTradeHistoryFirstAndLastTradeResponse>(
      API_URLS.getAccountTradeHistoryFirstAndLastTrade,
      requestBody,
    );
  }

  public getPeopleAlsoTradeData(params: PeopleAlsoTradeParams) {
    const APIPath = API_URLS.peopleAlsoTrade;
    const url = this.getBaseUrl() + APIPath;
    this.addOrUpdateCacheDefinition(
      url,
      CacheName.peopleAlsoTrade,
      HttpMethods.POST,
      PredefinedMilisecondsTypeEnum.oneHour,
      [ 'accountReferenceId' ], // Only account ID is dynamic here
    );

    return this.api.post<PeopleAlsoTradeItem[]>(APIPath, params);
  }

  public getBPInClosedMarket(requestBody: { accountReferenceId: string }) {
    // eslint-disable-next-line max-len
    return this.api.post<{ accountReferenceId: string, buyingPowerId: number }>(API_URLS.getBPInClosedMarket, requestBody);
  }

}
